__turbopack_context__.v({
  "active": "ChatHistoryPopup-module__X9KvMW__active",
  "bottomPopup": "ChatHistoryPopup-module__X9KvMW__bottomPopup",
  "bottomPopupOpen": "ChatHistoryPopup-module__X9KvMW__bottomPopupOpen",
  "emptyAction": "ChatHistoryPopup-module__X9KvMW__emptyAction",
  "emptyDescription": "ChatHistoryPopup-module__X9KvMW__emptyDescription",
  "focused": "ChatHistoryPopup-module__X9KvMW__focused",
  "newChatBtn": "ChatHistoryPopup-module__X9KvMW__newChatBtn",
  "popupOverlay": "ChatHistoryPopup-module__X9KvMW__popupOverlay",
  "threadActions": "ChatHistoryPopup-module__X9KvMW__threadActions",
  "threadContent": "ChatHistoryPopup-module__X9KvMW__threadContent",
  "threadGroup": "ChatHistoryPopup-module__X9KvMW__threadGroup",
  "threadHeader": "ChatHistoryPopup-module__X9KvMW__threadHeader",
  "threadItem": "ChatHistoryPopup-module__X9KvMW__threadItem",
  "threadPreview": "ChatHistoryPopup-module__X9KvMW__threadPreview",
  "threadTime": "ChatHistoryPopup-module__X9KvMW__threadTime",
  "threadTitle": "ChatHistoryPopup-module__X9KvMW__threadTitle",
  "threadTitleInput": "ChatHistoryPopup-module__X9KvMW__threadTitleInput",
});
